import { render, staticRenderFns } from "./ButtonSpinner.vue?vue&type=template&id=e34531b6"
import script from "./ButtonSpinner.vue?vue&type=script&lang=js"
export * from "./ButtonSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports